import React from 'react';
import Slider from 'react-slick';
import { useObservable } from 'react-use-observable';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import clsx from 'clsx';
import { EMPTY } from 'rxjs';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { settingsFactory } from 'v2/services/settings';

const TEN_SECONDS_IN_MS = 10000;

type ArrowProps = {
  onClick?: () => void;
  direction?: 'right' | 'left';
};

const Arrow = ({ onClick, direction = 'right' }: ArrowProps) => {
  return (
    <div
      className={clsx(
        'absolute top-1/2 z-1 -translate-y-1/2 cursor-pointer rounded-full leading-none text-black',
        direction === 'right' && '-right-7.5 max-md:-right-5',
        direction === 'left' && '-left-7.5 max-md:-left-5',
        !onClick && 'hidden'
      )}
      onClick={onClick}
    >
      {direction === 'right' ? <RightOutlined /> : <LeftOutlined />}
    </div>
  );
};

const Banner = () => {
  const [isLoading] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);

  const [banners] = useObservable(() => {
    if (isLoading === null || isLoading) return EMPTY;

    return settingsFactory.getBanners();
  }, [isLoading]);

  if (!banners?.length) return null;

  return (
    <>
      <Slider
        infinite={false}
        autoplay
        autoplaySpeed={TEN_SECONDS_IN_MS}
        prevArrow={<Arrow direction='left' />}
        nextArrow={<Arrow direction='right' />}
      >
        {banners.map(banner =>
          banner.link ? (
            <a key={banner.id} target='_blank' rel='noopener noreferrer' href={banner.link} className='banner-myeduzz'>
              <img className='w-full max-w-full' src={banner.imageUrl} alt='Banner' />
            </a>
          ) : (
            <div key={banner.id} className='banner-myeduzz mb-4 w-full [&_img]:max-w-full'>
              <img src={banner.imageUrl} alt='Banner' />
            </div>
          )
        )}
      </Slider>
    </>
  );
};

type ModuleProps = {
  module: string;
};

const Module = ({ module }: ModuleProps) => {
  const [isLoading] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);

  const [banner] = useObservable(() => {
    if (isLoading === null || isLoading) return EMPTY;
    return settingsFactory.getBanner(module);
  }, []);

  if (!banner) return null;

  if (banner.link) {
    return (
      <a target='_blank' rel='noopener noreferrer' href={banner.link} id='banner-myeduzz'>
        <img className='w-full max-w-full' src={banner.url} alt='Banner' />
      </a>
    );
  }

  return (
    <>
      <div className='mb-4 w-full [&_img]:max-w-full' id='banner-myeduzz'>
        <img src={banner.url} alt='Banner' />
      </div>
    </>
  );
};

Banner.Module = Module;

export default Banner;
